require('../scss/app.scss');
window.jQuery = window.$ = require('jquery');
require('slick-carousel');
require('magnific-popup');
require('../../node_modules/waypoints/lib/noframework.waypoints.js');


(function ($) {
    $(function () {

        $(window).scroll(function () {
            if ($(window).scrollTop() > 1) {
                $('html').addClass('has-scrolled');
            } else {
                $('html').removeClass('has-scrolled');
            }
        });

        $('.button__menu').click(function () {
            $('.header__menu').addClass('animate');
        });
        $('.menu__close').click(function () {
            $('.header__menu').removeClass('animate');
        });

        $('.button__search').click(function () {
            $('.header__search').addClass('animate');
        });
        $('.search__close').click(function () {
            $('.header__search').removeClass('animate');
        });

        $('.slider__home').slick({
            cssTransitions: true,
            accessibility: false,
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 2000,
            fade: true,
            infinite: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            waitForAnimate: true
        });
        $('.slider__brands').slick({
            accessibility: false,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 300,
            speed: 1,
            fade: true,
            infinite: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false
        });
        $('.slider__product').slick({
            accessibility: false,
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 4500,
            speed: 1000,
            fade: true,
            infinite: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false
        });

        $('.slider__timeline__text').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            fade: true,
            autoplay: true,
            autoplaySpeed: 5000,
            asNavFor: '.slider__timeline__year'
        });
        $('.slider__timeline__year').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.slider__timeline__text',
            dots: false,
            arrows: false,
            centerMode: true,
            focusOnSelect: true,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
            {
                breakpoint: 680,
                settings: {
                    slidesToShow: 2,
                    centerMode: false,
                }
            }
            ]
        });

        $('.do-gallery').magnificPopup({
            delegate: 'a',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0, 1],
                tCounter: '',
                tNext: false,
                tPrev: false
            },
            tLoading: false,
            type: 'image'
        });

        $('.filter__fake').click(function () {
            $(this).parent().toggleClass('animate');
        });

        $('.more-text-button').on('click tap', function () {
            $('.more-text-hidden').slideToggle();
            $(this).text(($(this).text() === $(this).attr('data-less')) ? $(this).attr('data-more') : $(this).attr('data-less'));
        });

        $('.view-list').click(function () {
            $('.view-list').addClass('animate');
            $('.view-grid').removeClass('animate');
            $('.category__products').addClass('animate');
        });
        $('.view-grid').click(function () {
            $('.view-grid').addClass('animate');
            $('.view-list').removeClass('animate');
            $('.category__products').removeClass('animate');
        });

        $('.icon-share').click(function () {
            $('.article__share').toggleClass('animate');
        });

        $('.footer__scroll').on('click', function (e) {
            $('html, body').animate({
                scrollTop: 0
            }, 750);
            e.preventDefault();
        });

        $(window).load(function () {
            $('.show-from-left').each(function () {
                new Waypoint({
                    element: this,
                    handler: function (direction) {
                        if (direction === 'down') {
                            $(this.element).addClass('animate');
                        } else {
                            $(this.element).removeClass('animate');
                        }
                    },
                    offset: '85%'
                });
            });
            $('.show-from-right').each(function () {
                new Waypoint({
                    element: this,
                    handler: function (direction) {
                        if (direction === 'down') {
                            $(this.element).addClass('animate');
                        } else {
                            $(this.element).removeClass('animate');
                        }
                    },
                    offset: '85%'
                });
            });
            $('.show-in-view').each(function () {
                new Waypoint({
                    element: this,
                    handler: function (direction) {
                        if (direction === 'down') {
                            $(this.element).addClass('animate');
                        } else {
                            $(this.element).removeClass('animate');
                        }
                    },
                    offset: '95%'
                });
            });
            $('.fade-in-view').each(function () {
                new Waypoint({
                    element: this,
                    handler: function (direction) {
                        if (direction === 'down') {
                            $(this.element).addClass('animate');
                        } else {
                            $(this.element).removeClass('animate');
                        }
                    },
                    offset: '85%'
                });
            });
            $('.fade').each(function () {
                new Waypoint({
                    element: this,
                    handler: function (direction) {
                        if (direction === 'down') {
                            $(this.element).addClass('animate');
                        } else {
                            $(this.element).removeClass('animate');
                        }
                    },
                    offset: '85%'
                });
            });
            $('.show').each(function () {
                new Waypoint({
                    element: this,
                    handler: function (direction) {
                        if (direction === 'down') {
                            $(this.element).addClass('animate');
                        } else {
                            $(this.element).removeClass('animate');
                        }
                    },
                    offset: '85%'
                });
            });
        });
        $(window).resize(function () {
            Waypoint.refreshAll();
        });

    });
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./assets/js/app.js
// module id = 0
// module chunks = 0